enum PresenceType {
    ONLINE = "on",
    OFFLINE = "of"
}

export default PresenceType;